export default __webpack_public_path__ + "static/media/large_balancing_tube_lt.d0077ed8.svg";